exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".range-slider-value{position:relative}.range-slider-value:after{position:absolute;top:8px;left:-7px;width:0;height:0;border-top:7px solid transparent;border-right:7px solid #0075ff;border-bottom:7px solid transparent;content:\"\"}", ""]);

// exports
